import * as React from "react";
import { forwardRef } from "react";
const SvgToolFlipHorizontal = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="#726f7e" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" strokeLinecap="round" strokeWidth={1.5}><path fillRule="evenodd" clipRule="evenodd" d="M11.9697 3L1.00002 21H11.9697L11.9697 3Z" fill="#CCCCCC" /><path fillRule="evenodd" clipRule="evenodd" d="M11.9698 3L22.9394 21H11.9698L11.9698 3Z" fill="#777777" /></g></svg>;
const ForwardRef = forwardRef(SvgToolFlipHorizontal);
export { ForwardRef as ReactComponent };